const intNweaConfig = {
  name: 'int',
  rootUrl: 'https://login.int.mapnwea.org/ui/',
  loginUrl: 'https://login.int.mapnwea.org/ui/login/',
  loggedInUrl: 'https://auth.int.nwea.org/adult/verifyHcpAuthorizationCode',
  loggedOutUrl: 'https://platform.int.heinemann.com/ui/login/logged-out/',
  helpUrl: 'https://connection.nwea.org/s/support?language=en_US',
  privacyPolicyUrl: 'https://www.nwea.org/policy/privacy-and-terms/',
  termsAndConditionsUrl:
    'https://www.nwea.org/policy/nwea-platform-terms-of-use/',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  restIdsGridApi: 'https://api.int.br.internal/ids-grid-api',
  hcpIdentityApiGateway:
    'https://app01.int.tsg.hmhco.com/hcp-identity-api-gateway',
  edsAuthorizationCode:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  susAuth: 'https://int.hmhone.app.hmhco.com/api/authorization',
  authorizationApi: 'https://int.hmhone.app.hmhco.com/api/authorization',
  edsInitUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/initializeUri',
  ampLogin: 'https://login.int.mapnwea.org/ui/login',
  nweaIssuer: 'https://sfp.int.tsg.hmhco.com/edcore/eds-login',
  nweaStartUrl: 'https://int03-start.mapnwea.org',
};

module.exports = intNweaConfig;
